class WareHourseQueryRequest {
  depotip_id: number;
  depo_sorumlu_id: number;
  aktif?: string = '';
}

export default WareHourseQueryRequest;
